
@if (field()) {
  <div class="radio-button-field__container">
    @if(field()!.title) {
      <h2 class="radio-button-field__title ci-heading-h6-semibold">
        {{ field()!.title }}
      </h2>
    }
    
    @if(field()!.description) {
      <p class="radio-button-field__description ci-caption-regular">
        {{ field()!.description }}
      </p>
    }
    
    @if( field()!.options && field()!.options!.length > 0 ) {
      <ul
        class="radio-button-field__options"
        [class.radio-button-field__options--grid]="field()!.options!.length > 3"
      >
        @for(option of field()!.options; track option) {
          <li class="radio-button-field__option" (click)="selectOption(option)">
            <ci-radio-button
              class="option__radio-button"
              [checked]="isSelected(option)"
            >
              <span
                slot="label"
                class="ci-paragraph-p1-regular"
              >
                {{ option }}
              </span>
            </ci-radio-button>
          </li>
        }
      </ul>
    }
    
    @if(field()!.required) {
      @if(showErrorMessage()) {
        <span class="radio-button__error-text ci-caption-regular">
          {{ 'Por favor, seleccione al menos una opción' | translate }}
        </span>
      } @else {
        <span class="radio-button__supporting-text ci-caption-regular">
          {{ 'Obligatorio' | translate }}
        </span>
      }
    }
  </div>
}



